// Today, as a "YYYY-MM-DD" string in the user's own timezone.
//
// The write-side counterpart to `parseEntryDate` (lib/finances.js), and it
// exists for the same reason. `new Date().toISOString().slice(0, 10)` gives
// the date in *UTC*, so in Jamaica (UTC-5) everything entered from 7pm local
// onward was stamped with tomorrow's date — an expense recorded at 8:30pm on
// 31 August landed in September, and one on New Year's Eve landed in the next
// tax year.
//
// Takes an optional Date so the behaviour is testable without faking a clock.
export function todayISO(date = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
